import styled from "styled-components";

export const PreviewStyles = styled.div`
  background: linear-gradient(#e3f1fd 0%, #b9d8f7 100%);
  .shipper {
    margin-top: 31px;
    height: 500px;
    padding: 0 10px;
    @media (max-width: 900px) {
      height: 777px;
      max-width: 900px;
    }
    @media (max-width: 415px) {
      height: 777px;
    }
    @media (max-width: 410px) {
      height: 820px;
    }
  }
  .carrier {
    margin-top: 31px;
    height: 500px;
    padding: 0 10px;
    @media (max-width: 900px) {
      height: 676px;
      max-width: 900px;
    }
    @media (max-width: 381px) {
      height: 696px;
    }
    @media (max-width: 377px) {
      height: 710px;
    }
  }
`;

export const PreviewIcon = styled.img`
  display: inline-block;
  width: 130px;
  height: 55px;
`;

export const PreviewLogo = styled.div`
  align-items: center;
  max-width: 300px;
  margin: 0 auto 60px;
`;

export const HeaderStyles = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PhonePreview = styled.img`
  display: inline-block;
  width: 24px;
  height: 24px;
`;

export const BodyStyles = styled.div`
  width: 100%;
  margin: 0 auto 80px;
  max-width: 1140px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .button-prepay {
    width: 280px;
  }
  .list {
    list-style-type: none;
    padding-bottom: 16px;
  }
  .img {
    padding: 5px 10px 0 0;
  }
  .pay-list-style {
    display: flex;
    flex-direction: column;
    max-width: 530px;
    @media (max-width: 900px) {
      order: 1;
    }
  }
  .point {
    display: flex;
    align-items: flex-start;
    @media (max-width: 900px) {
      font-size: 14px;
    }
  }
  .under-point {
    margin: 0px;
    font-size: 15px;
    line-height: 19px;
    @media (max-width: 900px) {
      font-size: 12px;
    }
  }
  .logo-contaiter {
    display: flex;
    @media (max-width: 900px) {
      order: 2;
      padding-top: 48px;
    }
  }

  @media (max-width: 900px) {
    flex-flow: wrap;
    flex-direction: column;
    padding: 48px 10px 0;
    max-width: 400px;
  }
`;

export const HumanLogoStyles = styled.img`
  display: flex;
  position: relative;
  bottom: 26px;
  display: inline-block;
  width: 502px;
  height: 546px;
  @media (max-width: 900px) {
    width: 320px;
    height: 348px;
    position: inherit;
  }
`;

export const FuelPromoLogoStyles = styled.img`
  display: flex;
  position: relative;
  bottom: 26px;
  display: inline-block;
  width: 502px;
  height: 546px;
  @media (max-width: 900px) {
    width: 280px;
    height: 238px;
    position: inherit;
  }
`;

export const TitleForStyle = styled.div`
  color: var(--glz-color-neutral-tone-4);
  font-size: 14px;
`;

export const NameCompanyStyle = styled.div`
  font-size: 40px;
  font-weight: 700;
`;

export const DescriptionStyle = styled.div`
  font-size: 22px;
  line-height: 33px;
  font-weight: 400;
`;

export const HeaderStyle = styled.div`
  display: flex;
  font-size: 28px;
  font-weight: bold;
  padding-bottom: 20px;
  line-height: 40px;
  @media (max-width: 900px) {
    font-size: 22px;
  }
`;
